import { render, staticRenderFns } from "./ChannelUi.vue?vue&type=template&id=6602fb53"
import script from "./ChannelUi.vue?vue&type=script&lang=js"
export * from "./ChannelUi.vue?vue&type=script&lang=js"
import style0 from "./ChannelUi.vue?vue&type=style&index=0&id=6602fb53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports